var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M16 8.00227V4.50292C16 3.67119 16 3.25532 15.8248 2.99974C15.6717 2.77645 15.4346 2.62477 15.1678 2.57935C14.8623 2.52737 14.4847 2.70164 13.7295 3.05019L4.85901 7.14426C4.18551 7.45511 3.84875 7.61054 3.60211 7.85159C3.38406 8.06469 3.21762 8.32482 3.1155 8.6121C3 8.93706 3 9.30795 3 10.0497V15.0023M16.5 14.5023H16.51M3 11.2023L3 17.8023C3 18.9224 3 19.4824 3.21799 19.9102C3.40973 20.2866 3.71569 20.5925 4.09202 20.7843C4.51984 21.0023 5.07989 21.0023 6.2 21.0023H17.8C18.9201 21.0023 19.4802 21.0023 19.908 20.7843C20.2843 20.5925 20.5903 20.2866 20.782 19.9102C21 19.4824 21 18.9224 21 17.8023V11.2023C21 10.0822 21 9.52211 20.782 9.09429C20.5903 8.71797 20.2843 8.412 19.908 8.22026C19.4802 8.00227 18.9201 8.00227 17.8 8.00227L6.2 8.00227C5.0799 8.00227 4.51984 8.00227 4.09202 8.22026C3.7157 8.412 3.40973 8.71796 3.21799 9.09429C3 9.52211 3 10.0822 3 11.2023ZM17 14.5023C17 14.7784 16.7761 15.0023 16.5 15.0023C16.2239 15.0023 16 14.7784 16 14.5023C16 14.2261 16.2239 14.0023 16.5 14.0023C16.7761 14.0023 17 14.2261 17 14.5023Z",
    stroke: "#6366F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.6c5a8d910c1dc3e1b5f1e982d0430902.svg";
export { ForwardRef as ReactComponent };